import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './RewardWallet.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

function RewardWallet({ redemption, onClose }) {
  const [qrCode, setQrCode] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQRCode = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(
          `${API_URL}/wallet/qr/${redemption.id}`,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );
        setQrCode(response.data.qrCode);
      } catch (error) {
        console.error('Failed to fetch QR code:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchQRCode();
  }, [redemption.id]);

  const handleDownload = () => {
    // Create canvas to generate downloadable image
    const canvas = document.createElement('canvas');
    canvas.width = 600;
    canvas.height = 800;
    const ctx = canvas.getContext('2d');

    // Background
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, 600, 800);

    // Header
    const gradient = ctx.createLinearGradient(0, 0, 600, 100);
    gradient.addColorStop(0, '#667eea');
    gradient.addColorStop(1, '#764ba2');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, 600, 100);

    // Title
    ctx.fillStyle = '#ffffff';
    ctx.font = 'bold 32px Arial';
    ctx.textAlign = 'center';
    ctx.fillText('Loyalty Reward', 300, 60);

    // Reward name
    ctx.fillStyle = '#1f2937';
    ctx.font = 'bold 24px Arial';
    ctx.fillText(redemption.rewardName, 300, 160);

    // QR Code
    if (qrCode) {
      const img = new Image();
      img.onload = () => {
        ctx.drawImage(img, 150, 200, 300, 300);

        // Code
        ctx.fillStyle = '#4b5563';
        ctx.font = '20px monospace';
        ctx.fillText(`Code: ${redemption.code}`, 300, 540);

        // Expires
        ctx.font = '16px Arial';
        ctx.fillText(
          `Expires: ${new Date(redemption.expiresAt).toLocaleDateString()}`,
          300,
          580
        );

        // Instructions
        ctx.font = '14px Arial';
        ctx.fillStyle = '#6b7280';
        ctx.fillText('Show this code at checkout to redeem', 300, 620);

        // Download
        const link = document.createElement('a');
        link.download = `reward-${redemption.code}.png`;
        link.href = canvas.toDataURL();
        link.click();
      };
      img.src = qrCode;
    }
  };

  const handleAddToAppleWallet = () => {
    alert('Apple Wallet integration requires signing certificates. This feature will be available in production.');
    // In production, this would trigger .pkpass file download
  };

  const handleAddToGoogleWallet = () => {
    alert('Google Wallet integration requires API credentials. This feature will be available in production.');
    // In production, this would redirect to Google Pay save URL
  };

  const handleCopyCode = () => {
    navigator.clipboard.writeText(redemption.code);
    alert('Code copied to clipboard!');
  };

  return (
    <div className="wallet-modal-overlay" onClick={onClose}>
      <div className="wallet-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>×</button>
        
        <div className="wallet-header">
          <h2>🎁 Your Reward</h2>
          <p>{redemption.rewardName}</p>
        </div>

        {loading ? (
          <div className="wallet-loading">Loading QR code...</div>
        ) : (
          <>
            <div className="qr-code-container">
              {qrCode && <img src={qrCode} alt="QR Code" className="qr-code" />}
            </div>

            <div className="redemption-code">
              <div className="code-label">Redemption Code</div>
              <div className="code-value">{redemption.code}</div>
              <button className="btn-copy" onClick={handleCopyCode}>
                📋 Copy Code
              </button>
            </div>

            <div className="redemption-info">
              <div className="info-row">
                <span className="info-label">Points Used:</span>
                <span className="info-value">{redemption.pointsCost}</span>
              </div>
              <div className="info-row">
                <span className="info-label">Expires:</span>
                <span className="info-value">
                  {new Date(redemption.expiresAt).toLocaleDateString()}
                </span>
              </div>
            </div>

            <div className="wallet-actions">
              <button className="btn btn-download" onClick={handleDownload}>
                📥 Download Image
              </button>
              <button className="btn btn-apple-wallet" onClick={handleAddToAppleWallet}>
                 Add to Apple Wallet
              </button>
              <button className="btn btn-google-wallet" onClick={handleAddToGoogleWallet}>
                🅖 Add to Google Wallet
              </button>
            </div>

            <div className="wallet-instructions">
              <h4>How to use:</h4>
              <ol>
                <li>Show this QR code or redemption code at checkout</li>
                <li>Staff will scan the code or enter it manually</li>
                <li>Your discount will be applied automatically</li>
              </ol>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default RewardWallet;
